import * as React from 'react';

export const ChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path fill="currentColor" d="M15.7 12l-6-6-1.4 1.4 4.6 4.6-4.6 4.6L9.7 18l6-6z" />
    </svg>
  );
};

export const ChevronLeftIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props} data-testid="chevron-left-icon">
      <path fill="currentColor" d="M8.3 12l6 6 1.4-1.4-4.6-4.6 4.6-4.6L14.3 6l-6 6z" />
    </svg>
  );
};

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 15.7l6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 9.7l6 6z" fill="currentColor" />
    </svg>
  );
};

export const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" fill="currentColor" />
    </svg>
  );
};

export const LogoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="40" viewBox="0 0 72 40" fill="none" {...props}>
      <path
        fillRule="evenodd"
        d="M16.2 39h39.7L72 19.5 55.9 0H16.2L0 19.5 16.2 39zM55 37H17L2.6 19.4 17.1 2H55l14.5 17.6L55 36.9zM17 19.1v6.9h-2.2V10.8h4.3c1.2 0 2 .3 2.8 1 .6.8 1 1.7 1 3a4 4 0 01-.6 2.2c-.3.6-.8 1-1.4 1.3.3.1.6.4.9.7l.4 1.5.6 5.5h-2.2l-.5-5.3c-.1-.5-.2-.9-.5-1.1-.2-.2-.5-.4-1-.4H17zm0-6.4v4.4H19c.5 0 1-.1 1.2-.5.4-.4.5-1 .5-1.7 0-.8-.2-1.3-.5-1.7-.2-.3-.7-.5-1.2-.5H17zm13 13c-.5.3-1.2.5-2 .5s-1.4-.2-2-.6c-.6-.3-1.1-.9-1.4-1.6-.4-.6-.5-1.5-.5-2.4v-2c0-1 .1-1.8.5-2.5A3.7 3.7 0 0128 15c.8 0 1.4.2 2 .6.6.4 1.1.9 1.4 1.6.4.7.5 1.5.5 2.4v2.1c0 1-.1 1.8-.5 2.4-.3.7-.8 1.3-1.4 1.6zm-3.4-2.1c.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6.3-.5.5-1.1.5-2v-2.2a3 3 0 00-.5-1.9c-.4-.4-.8-.6-1.4-.6-.6 0-1 .2-1.4.6a3 3 0 00-.5 1.9v2.3c0 .8.2 1.4.5 1.9zm13.5 1.7c-.6.6-1.5 1-2.5 1-1.2 0-2.2-.5-2.9-1.3a5 5 0 01-1-3.4v-2a5 5 0 011-3.4c.8-.9 1.7-1.3 3-1.3 1 0 1.9.3 2.5 1 .6.5 1 1.4 1.2 2.5l-2 .5c-.2-1.4-.8-2-1.8-2-.6 0-1 .2-1.4.6-.3.5-.5 1.1-.5 1.9v2.3c0 .8.2 1.4.5 1.9.4.4.8.6 1.4.6.5 0 .9-.1 1.2-.5.3-.3.5-.8.6-1.5l2 .5c-.2 1.1-.6 2-1.3 2.6zm4.9-6.5V26h-2V10.8h2V16c.2-.3.5-.5 1-.8a3 3 0 011.4-.3c1 0 1.7.3 2.2 1 .5.5.8 1.4.8 2.5V26h-2v-7.2c0-.6-.2-1.1-.5-1.5-.3-.3-.7-.5-1.2-.5s-1 .2-1.2.5A2 2 0 0045 19zm13.6-2.7c.6.8 1 2 1 3.3V21H54v.9c0 .8.2 1.4.5 1.9.4.4.8.6 1.3.6s.9-.1 1.2-.5c.3-.3.5-.7.6-1.3l1.8.4c-.1 1-.5 1.8-1.1 2.4-.7.6-1.5.9-2.5.9-1.2 0-2-.4-2.8-1.3-.7-.8-1-2-1-3.4v-2c0-1 .1-1.7.5-2.5.3-.6.8-1.2 1.3-1.6.6-.3 1.3-.5 2-.5 1.2 0 2 .4 2.8 1.2zm-1.4 1.3c-.4-.5-.8-.7-1.4-.7-.5 0-1 .2-1.2.7-.4.4-.5 1-.5 1.8v.3h3.5v-.4a3 3 0 00-.4-1.7z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M10 18a8 8 0 004.9-1.7l4.4 4.4 1.4-1.4-4.4-4.4A8 8 0 1010 18zm0-14a6 6 0 110 12 6 6 0 010-12z" />
    </svg>
  );
};

export const SearchMobileIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        d="M22.167 13.333a7.833 7.833 0 1 1-15.667 0 7.833 7.833 0 0 1 15.667 0Zm-2.568 7.708a9.333 9.333 0 1 1 1.168-.945l6.121 6.733-1.11 1.009L19.6 21.04Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const ArrowUpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M12.8 21.2V6.6L18 12l1.4-1.4-7.7-7.7L4 10.5l1.4 1.4 5.3-5.3v14.6h2z" />
    </svg>
  );
};

export const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M10.8 2.8v14.6L5.5 12l-1.4 1.4 7.7 7.7 7.7-7.7-1.4-1.4-5.3 5.3V2.8h-2z" />
    </svg>
  );
};

export const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" fill="currentColor" />
    </svg>
  );
};

export const ArrowUpDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 9 25" {...props}>
      <path
        d="M4.85355 0.646447C4.65829 0.451184 4.34171 0.451184 4.14645 0.646447L0.964466 3.82843C0.769204 4.02369 0.769204 4.34027 0.964466 4.53553C1.15973 4.7308 1.47631 4.7308 1.67157 4.53553L4.5 1.70711L7.32843 4.53553C7.52369 4.7308 7.84027 4.7308 8.03553 4.53553C8.2308 4.34027 8.2308 4.02369 8.03553 3.82843L4.85355 0.646447ZM4.14645 24.3536C4.34171 24.5488 4.65829 24.5488 4.85355 24.3536L8.03553 21.1716C8.2308 20.9763 8.2308 20.6597 8.03553 20.4645C7.84027 20.2692 7.52369 20.2692 7.32843 20.4645L4.5 23.2929L1.67157 20.4645C1.47631 20.2692 1.15973 20.2692 0.964465 20.4645C0.769203 20.6597 0.769203 20.9763 0.964465 21.1716L4.14645 24.3536ZM4 1L4 24L5 24L5 1L4 1Z"
        fill="#21201F"
      />
    </svg>
  );
};

export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" />
    </svg>
  );
};

export const CheckMarkIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M20.5 6.4l-11 11L8.1 16l-4.6-4.6L4.9 10l4.6 4.6L19.1 5l1.4 1.4z" clipRule="evenodd" />
    </svg>
  );
};

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      data-testid="close-icon"
      {...props}
    >
      <path d="M17.6 5L12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4 17.6 5z" />
    </svg>
  );
};

export const StethoscopeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path
        d="M13.5.5H12V2h1.5v2.16a2.31 2.31 0 0 1-1.8 2.3A2.25 2.25 0 0 1 9 4.25V2h1.5V.5H9A1.5 1.5 0 0 0 7.5 2v2.1a3.89 3.89 0 0 0 3 3.81v2.34a3.75 3.75 0 0 1-7.5 0V7.87a2.25 2.25 0 1 0-1.5 0v2.38a5.25 5.25 0 0 0 10.5 0V7.92a3.75 3.75 0 0 0 3-3.67V2A1.5 1.5 0 0 0 13.5.5ZM2.25 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
        fill="#544F4F"
      />
    </svg>
  );
};

export const CalenderFillerIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" {...props}>
      <path d="M12.75 2h-1.5V.5h-1.5V2h-4.5V.5h-1.5V2h-1.5c-.82 0-1.5.67-1.5 1.5V14c0 .82.68 1.5 1.5 1.5h10.5c.82 0 1.5-.68 1.5-1.5V3.5c0-.83-.68-1.5-1.5-1.5Zm0 4.5V14H2.25V6.5h10.5ZM5.25 8h-1.5v1.5h1.5V8Zm1.5 0h1.5v1.5h-1.5V8Zm4.5 0h-1.5v1.5h1.5V8Zm-7.5 3h1.5v1.5h-1.5V11Zm4.5 0h-1.5v1.5h1.5V11Zm1.5 0h1.5v1.5h-1.5V11Z" />
    </svg>
  );
};

export const ArrowLightUpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.00008 4.66675L12.6189 9.66675H3.38128L8.00008 4.66675Z" fill="#12B76A" />
    </svg>
  );
};

export const ArrowLightDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.0001 11.3334L3.3813 6.33343L12.6189 6.33343L8.0001 11.3334Z" fill="#8C0000" />
    </svg>
  );
};
export const ArrowLightBidirectionalIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.59827 3.5L12.4954 7.25H4.70115L8.59827 3.5Z" fill="#544f4f" />
      <path d="M8.59827 12.5L4.70115 8.75L12.4954 8.75L8.59827 12.5Z" fill="#544f4f" />
    </svg>
  );
};
export const GmailIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 26" {...props}>
      <path
        d="M7.36035 23.279V12.5783L3.98639 9.54221L0.960938 7.85742V21.3906C0.960938 22.4355 1.82166 23.279 2.88076 23.279H7.36035Z"
        fill="#4285F4"
      />
      <path
        d="M22.7188 23.279H27.1983C28.2606 23.279 29.1182 22.4324 29.1182 21.3906V7.85742L25.6914 9.78728L22.7188 12.5783V23.279Z"
        fill="#34A853"
      />
      <path
        d="M7.35949 12.5793L6.90039 8.39823L7.35949 4.39648L15.0388 10.0615L22.7181 4.39648L23.2317 8.18215L22.7181 12.5793L15.0388 18.2444L7.35949 12.5793Z"
        fill="#EA4335"
      />
      <path
        d="M22.7188 4.39566V12.5785L29.1182 7.85764V5.33984C29.1182 3.00458 26.408 1.67329 24.5106 3.07382L22.7188 4.39566Z"
        fill="#FBBC04"
      />
      <path
        d="M0.960938 7.85764L3.90414 10.0289L7.36035 12.5785V4.39566L5.56852 3.07382C3.66789 1.67329 0.960938 3.00458 0.960938 5.33984V7.85764Z"
        fill="#C5221F"
      />
    </svg>
  );
};

export const ClinicalTrialsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <rect width="24" height="24" rx="5" fill="#FEE6EC" />
      <path
        d="M20 2H18V4H20V6.88C20.0129 7.58826 19.7812 8.27929 19.344 8.83668C18.9069 9.39406 18.2909 9.78372 17.6 9.94C17.1641 10.029 16.7138 10.0199 16.2819 9.91339C15.8499 9.80688 15.447 9.60563 15.1024 9.32421C14.7578 9.04279 14.4801 8.68824 14.2894 8.28626C14.0988 7.88427 13.9999 7.44491 14 7V4H16V2H14C13.4696 2 12.9609 2.21071 12.5858 2.58579C12.2107 2.96086 12 3.46957 12 4V6.79C11.9895 7.96658 12.3799 9.11167 13.1069 10.0368C13.834 10.962 14.8543 11.612 16 11.88V15C16 16.3261 15.4732 17.5979 14.5355 18.5355C13.5979 19.4732 12.3261 20 11 20C9.67392 20 8.40215 19.4732 7.46447 18.5355C6.52679 17.5979 6.00001 16.3261 6.00001 15V11.82C6.66722 11.5841 7.22956 11.1199 7.58764 10.5095C7.94571 9.89911 8.07647 9.18176 7.9568 8.48427C7.83713 7.78677 7.47474 7.15404 6.93367 6.6979C6.3926 6.24175 5.70769 5.99157 5.00001 5.99157C4.29232 5.99157 3.60741 6.24175 3.06635 6.6979C2.52528 7.15404 2.16288 7.78677 2.04321 8.48427C1.92354 9.18176 2.0543 9.89911 2.41237 10.5095C2.77045 11.1199 3.33279 11.5841 4.00001 11.82V15C4.00001 16.8565 4.7375 18.637 6.05026 19.9497C7.36301 21.2625 9.14349 22 11 22C12.8565 22 14.637 21.2625 15.9498 19.9497C17.2625 18.637 18 16.8565 18 15V11.89C19.1277 11.6598 20.1414 11.0476 20.8702 10.1568C21.5989 9.26592 21.9979 8.15094 22 7V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM5.00001 8C5.19779 8 5.39113 8.05865 5.55558 8.16853C5.72003 8.27841 5.8482 8.43459 5.92389 8.61732C5.99957 8.80004 6.01938 9.00111 5.98079 9.19509C5.94221 9.38907 5.84697 9.56725 5.70711 9.70711C5.56726 9.84696 5.38908 9.9422 5.1951 9.98079C5.00112 10.0194 4.80005 9.99957 4.61732 9.92388C4.4346 9.84819 4.27842 9.72002 4.16854 9.55557C4.05866 9.39112 4.00001 9.19778 4.00001 9C4.00001 8.73478 4.10536 8.48043 4.2929 8.29289C4.48044 8.10536 4.73479 8 5.00001 8Z"
        fill="#C40000"
      />
    </svg>
  );
};

export const PublicationsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <rect width="24" height="24" rx="5" fill="#E4F5F1" />
      <path
        d="M18 22H6C4.9 22 4 21.1 4 20V5C4 3.3 5.3 2 7 2H20V4H7C6.4 4 6 4.4 6 5C6 5.6 6.4 6 7 6H20V20C20 21.1 19.1 22 18 22ZM6 7.8V20H18V8H7C6.6 8 6.3 7.9 6 7.8Z"
        fill="#00A17C"
      />
    </svg>
  );
};

export const LocationIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M5 9a7 7 0 1114 0c0 5.3-7 13-7 13S5 14.2 5 9zm7-5a5 5 0 00-5 5c0 2.8 3 7.2 5 9.9 2.1-2.7 5-7 5-9.9a5 5 0 00-5-5zm2.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
    </svg>
  );
};

export const ListIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
    </svg>
  );
};

export const GraphViewIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12H12V6H10.5V0H16.5V6H15V12ZM4.48975 12.4064C4.94237 12.6696 5.31823 13.0466 5.58 13.5H30V16.5H5.58C5.31823 16.9534 4.94237 17.3304 4.48975 17.5936C4.03714 17.8567 3.52354 17.9968 3 18C2.20435 18 1.44129 17.6839 0.878679 17.1213C0.31607 16.5587 0 15.7956 0 15C0 14.2043 0.31607 13.4413 0.878679 12.8787C1.44129 12.3161 2.20435 12 3 12C3.52354 12.0032 4.03714 12.1433 4.48975 12.4064ZM19.5 18H16.5V24H15V30H21V24H19.5V18ZM7.5 18H10.5V24H12V30H6V24H7.5V18ZM28.5 18H25.5V24H24V30H30V24H28.5V18ZM24 12H21V6H19.5V0H25.5V6H24V12Z"
      />
    </svg>
  );
};

export const BurgerMenuTriangleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 4.87305H2.25V6.37305H15.75V4.87305ZM13.5 8.62305H4.5V10.123H13.5V8.62305ZM7.5 12.373H10.5V13.873H7.5V12.373Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CrossIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M20 5.4L18.6 4 12 10.6 5.4 4 4 5.4l6.6 6.6L4 18.6 5.4 20l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L20 5.4z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const DisclaimerIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81 80" {...props}>
      <g clipPath="url(#a)">
        <path
          fill="#CCE0F5"
          d="M21.6 64.75a1.86 1.86 0 0 1-1.86-1.86V8.2c0-1.02.83-1.86 1.86-1.86h42.82c1.02 0 1.85.84 1.85 1.86v54.7c0 1.02-.83 1.86-1.85 1.86H21.6Z"
        />
        <path
          fill="#589AE1"
          d="M64.42 6.83c.75 0 1.37.61 1.37 1.37v54.7c0 .75-.62 1.37-1.37 1.37H21.6c-.76 0-1.37-.62-1.37-1.37V8.2c0-.76.61-1.37 1.37-1.37h42.82Zm0-.98H21.6a2.35 2.35 0 0 0-2.35 2.35v54.7a2.35 2.35 0 0 0 2.35 2.34h42.82a2.34 2.34 0 0 0 2.34-2.34V8.2c0-1.3-1.05-2.35-2.34-2.35Z"
        />
        <path
          fill="#F7F9FC"
          d="M11.75 73.66c-.56 0-1-.47-1-1.05V29.47l15.32-15.32h30.5c.55 0 1 .46 1 1.04v57.42c0 .58-.45 1.05-1 1.05H11.75Z"
        />
        <path
          fill="#589AE1"
          d="M56.57 14.63c.29 0 .52.25.52.56v57.42c0 .31-.24.56-.52.56H11.75c-.29 0-.52-.25-.52-.56V29.67l15.04-15.04h30.3Zm0-.97h-30.7l-15.61 15.6v43.35c0 .85.67 1.54 1.5 1.54h44.8c.83 0 1.5-.7 1.5-1.54V15.2a1.5 1.5 0 0 0-1.49-1.53Z"
        />
        <path
          fill="#B2D1F0"
          d="M52.24 68.85 43 74.15l2.5-10.33 2.9-3.88c.53-.69 1.28-1 1.7-.69l5.24 3.9c.41.32.33 1.13-.18 1.82l-2.92 3.88Z"
        />
        <path
          fill="#CCE0F5"
          d="M52.2 67.93a.24.24 0 0 1-.14-.05l-5.59-4.17a.23.23 0 0 1-.05-.32l19.53-26.01a1.46 1.46 0 0 1 2.06-.3l3.61 2.71a1.45 1.45 0 0 1 .3 2.04L52.39 67.84a.26.26 0 0 1-.19.1Z"
        />
        <path
          fill="#589AE1"
          d="M67.12 37.28c.21 0 .42.07.59.2l3.62 2.7a.96.96 0 0 1 .2 1.35L52.14 67.34l-5.18-3.87 19.37-25.8a1 1 0 0 1 .78-.4Zm0-.98c-.6 0-1.18.27-1.56.78L46.03 63.1a.72.72 0 0 0 .15 1.01l5.58 4.17a.73.73 0 0 0 1.02-.14l19.52-26c.65-.87.47-2.09-.39-2.73l-3.62-2.7a1.9 1.9 0 0 0-1.17-.4Z"
        />
        <path
          fill="#fff"
          d="m45.95 64.03 2.84-3.8c.32-.42.7-.6.92-.6a.2.2 0 0 1 .1.02l5.23 3.9c.05.04.06.12.07.15.03.2-.05.58-.35.98l-2.85 3.8-8.16 4.68 2.2-9.13Z"
        />
        <path
          fill="#589AE1"
          d="m49.64 60.13 4.98 3.71c-.01.12-.08.32-.25.55l-2.79 3.71-7.1 4.07 1.92-7.93 2.79-3.72c.17-.22.35-.34.45-.4Zm.07-1c-.41 0-.92.3-1.3.8l-2.91 3.89L43 74.15l9.24-5.3 2.92-3.87c.51-.7.6-1.5.18-1.82l-5.24-3.9a.64.64 0 0 0-.4-.13Z"
        />
        <path
          fill="#589AE1"
          d="m52.35 68.7-6.74-5.03 17.63-23.5L70 45.21l-17.64 23.5Zm-5.12 3.03L43 74.15l1.15-4.73 3.08 2.3Z"
        />
        <path fill="#99C2EB" d="m50.23 67.13-2.68-2L65.3 41.7l2.68 2-17.75 23.43Z" />
        <path fill="#F7F9FC" d="m11.43 28.78 13.95-13.95v13.95H11.43Z" />
        <path fill="#589AE1" d="M24.9 16.01V28.3H12.6l12.3-12.29Zm.97-2.35-15.61 15.6h15.6v-15.6Z" />
        <path fill="#CCE0F5" d="M25.9 29.27 11.25 43.72V29.27h14.67Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5 0h80v80H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckboxCheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4 7.846L2 9.194L7 14L16 5.346L14.6 4L7 11.308L3.4 7.846ZM16 18H2C0.895 18 0 17.105 0 16V2C0 0.896 0.895 0 2 0H16C17.104 0 18 0.896 18 2V16C18 17.105 17.104 18 16 18Z"
        fill="#0B41CD"
      />
    </svg>
  );
};

export const CheckboxEmptyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 16H16V2H2V16ZM16 18H2C0.896 18 0 17.104 0 16V2C0 0.895 0.896 0 2 0H16C17.104 0 18 0.895 18 2V16C18 17.104 17.104 18 16 18Z"
        fill="#706B69"
      />
    </svg>
  );
};

export const ThreeDotsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0195 7.25391C11.1911 7.25391 10.5195 6.58233 10.5195 5.75391C10.5195 4.92548 11.1911 4.25391 12.0195 4.25391C12.848 4.25391 13.5195 4.92548 13.5195 5.75391C13.5195 6.58233 12.848 7.25391 12.0195 7.25391ZM10.5595 12.2539C10.5595 13.0823 11.2311 13.7539 12.0595 13.7539C12.888 13.7539 13.5595 13.0823 13.5595 12.2539C13.5595 11.4255 12.888 10.7539 12.0595 10.7539C11.2311 10.7539 10.5595 11.4255 10.5595 12.2539ZM10.5195 18.7539C10.5195 19.5823 11.1911 20.2539 12.0195 20.2539C12.848 20.2539 13.5195 19.5823 13.5195 18.7539C13.5195 17.9255 12.848 17.2539 12.0195 17.2539C11.1911 17.2539 10.5195 17.9255 10.5195 18.7539Z"
        fill="#0B41CD"
      />
    </svg>
  );
};

export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20.4 20L12 4.1L3.59996 20H20.4ZM11.1 1.6C11.3 1.2 11.6 1 12 1C12.3 1 12.7 1.2 12.9 1.6L22.9 20.5C23.3 21.2 22.8 22 22 22H2.09996C1.29996 22 0.799963 21.2 1.09996 20.4L11.1 1.6ZM12.9999 9H10.9999V14H12.9999V9ZM10.9999 18H12.9999V16H10.9999V18Z"
        fill="#FFC414"
      />
    </svg>
  );
};

export const CloseOutlinedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" />
    </svg>
  );
};

export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 18H16C17.1 18 18 17.1 18 16V8H16V16H2V2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18ZM16.2 0.599976L17.4 1.79999C18.2 2.49999 18.2 3.79998 17.4 4.59998L8 14H4V10L13.4 0.599976C13.8 0.199976 14.3 0 14.8 0C15.3 0 15.8 0.199976 16.2 0.599976ZM6 12H7.2L16 3.20001L14.8 2L6 10.8V12Z"
        fill="#0B41CD"
      />
    </svg>
  );
};
